<template>
  <v-form ref="form">
    <v-row dense>
      <v-col cols="6">
        <v-text-field
          v-model="action.name"
          :rules="rules.name"
          clearable
          dense
          outlined
          :label="$t('commons.name')"
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-model="action.type_action"
          :items="actionTypes"
          :rules="rules.type_action"
          dense
          outlined
          :label="$t('commons.type')"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="action.description"
          dense
          outlined
          :label="$t('commons.description')"
        />
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="action.user"
          :items="users"
          :rules="rules.user"
          dense
          outlined
          item-text="email"
          item-value="id"
          :label="$t('commons.intended_for')"
        />
      </v-col>
      <v-col cols="4">
        <DatetimePicker
          v-model="action.end_date"
          :min="nonConformity.created_at"
          :textFieldProps="{
            dense: true,
            label: $t('commons.date.end_date'),
            rules: rules.endDate
          }"
        ></DatetimePicker>
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="action.status"
          :items="statusItems"
          :rules="rules.status"
          dense
          outlined
          :label="$t('commons.status.name')"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="pb-4 pr-4 d-flex justify-end">
      <template v-if="saving">
        <v-progress-circular
          indeterminate
          size="20"
          color="primary"
        ></v-progress-circular>
      </template>
      <avs-saveButton
        v-else
        :disabled="isSaved"
        @click="handleSave"
      />
    </v-row>
  </v-form>
</template>

<script>
import { required } from "@/utils/validator"
import DatetimePicker from "@/components/inputs/DatetimePicker.vue"
import TeamService from "@/services/TeamService"
import NonConformityService from "@/services/NonConformityService"
import { STATUS_ITEMS, STATUS_ITEMS_DISABLED } from "@/utils/consts"
import { isInspector } from "@/utils/middleware"
export default {
  components: {
    DatetimePicker
  },
  name: "NonConformityAction",
  props: {
    value: {
      type: Object,
      required: true
    },
    isSaved: {
      type: Boolean,
      default: false
    },
    nonConformity: {
      type: Object,
      required: true
    },
    projectId: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchUser()
  },
  data() {
    return {
      action: { ...this.value },
      actionTypes: ["Preventive", "Corrective"],
      rules: {
        endDate: [required],
        name: [required],
        non_conformity: [required],
        type_action: [required],
        status: [required],
        user: [required]
      },
      users: [],
      saving: false
    }
  },
  computed: {
    statusItems() {
      return isInspector(this.projectRole) ? STATUS_ITEMS : STATUS_ITEMS_DISABLED
    },
    projectRole() {
      return this.$store.state.app.project.role
    }
  },
  methods: {
    async fetchUser() {
      const response = await TeamService.getTeam(this, this.projectId)
      this.users = response
    },
    async updateAction() {
      this.saving = true
      this.action.lang = this.$i18n.locale
      return NonConformityService.updateAction(this.action.id, this.action)
        .then(response => {
          this.$emit("update", response)
          this.send(
            this.$t("messages.success.updated", { entity: this.$t("commons.action") }),
            "success"
          )
          this.saving = false
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    },
    async createAction() {
      this.saving = true
      this.action.lang = this.$i18n.locale
      return NonConformityService.createAction(this.nonConformity.id, this.action)
        .then(response => {
          this.$emit("update", response)
          this.send(
            this.$t("messages.success.saved", { entity: this.$t("commons.action") }),
            "success"
          )
          this.saving = false
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
    },
    handleSave() {
      if (this.validate()) {
        const p = this.action.id ? this.updateAction() : this.createAction()
        p.then(e => {
          this.$emit("isSaved", true)
        })
      }
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    },
    validate() {
      return this.$refs.form.validate()
    }
  },
  watch: {
    action: {
      deep: true,
      handler(newValue, oldValue) {
        this.$emit("isSaved", false)
      }
    }
  }
}
</script>
